import React from 'react';
import PropTypes from 'prop-types';
import WelcomeBackComponent from './WelcomeBack';
import SignInByIdComponent from './SignInById';
import ThirdPartyForm from './ThirdPartyForm';
import SocialProvider from './SocialProvider';
import SocialProviders from './SocialProviders';

import { connect } from 'react-redux';
import { socialLoginOpenWindow } from '../../actions/auth';
import './styles.scss';

const propTypes ={
  providerName: PropTypes.string,
  preferredUsername: PropTypes.string,
  removeModal: PropTypes.func,
};

const defaultProps = {
  providers: ['facebook','twitter','yahoo','google', 'apple'],
  preferredUsername: 'DJofNature',
  removeModal: _.noop(),
};

class SocialLogin extends React.Component {

  constructor(props) {
    super(props);
    this.useAnotherAccount = this.useAnotherAccount.bind(this);
    this.signIn = this.signIn.bind(this);
    this.wrongUser = this.wrongUser.bind(this);
    this.submit = this.submit.bind(this);
    this.socialLogin = this.socialLogin.bind(this);
    this.state = {
      socialProvider: '',
      activePanel: '',
      janrainEmbed: ''
    }
  }

  useAnotherAccount(){}
  signIn (){}
  wrongUser(){}
  submit(values){}

  socialLogin(provider){
    this.props.dispatch(socialLoginOpenWindow(provider, this.props.removeModal));
  }

  render(){
    const {className} = this.props;
    const providerPanel = (this.props.providerName && this.props.email) ?
      (<SocialProvider provider={this.props.providerName} email={this.props.email} />) :
      (<SocialProviders providers={this.props.providers} socialLogin={this.socialLogin} />);
      return (
        <div className={className}>
          {providerPanel}
        </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    providerName: state.auth.providerName,
    email: state.auth.email,
    className: ownProps.className
  };
}

SocialLogin.propTypes = propTypes;
SocialLogin.defaultProps = defaultProps;

export default connect(mapStateToProps)(SocialLogin);
